import { isNativeApp } from 'utils/nativeOAuth';

interface BrowserPlugin {
  open(options: { url: string }): Promise<void>;
}

/**
 * Open an external URL.
 *
 * On the web, opens a new tab. Inside the native app, opens an in-app Safari
 * View Controller (via the @capacitor/browser plugin) instead of kicking the
 * user out to the external Safari app — required by App Store Guideline 4
 * (web content must be shown *within* the app, e.g. the sign-up / book-a-demo
 * link). Falls back to in-WebView navigation if the plugin isn't present.
 *
 * The plugin is read off `window.Capacitor` (same approach as nativeOAuth.ts),
 * so thera-fe needs no @capacitor/* build dependency — the native app provides
 * @capacitor/browser at runtime.
 */
export function openExternalUrl(url: string): void {
  if (!isNativeApp()) {
    window.open(url, '_blank');
    return;
  }

  const browser = (window as { Capacitor?: { Plugins?: { Browser?: BrowserPlugin } } }).Capacitor?.Plugins?.Browser;
  if (browser) {
    void browser.open({ url });
  } else {
    window.location.href = url;
  }
}
